<template>
  <div class="Melamine">
    <div class="title">Vinyl Acetate Monomer</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Index" label="Index"> </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>
        In ISO tanks, 22mt per tank or in 190kg drums, 15.2mt/20'FCL, or in
        bulk.
      </p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        VAM is a key ingredient in emulsion polyymers, resins, and intermediates
        use polyethylene compounds, laminated safety glasss, packaging,
        automotive plastic fuel
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "Appearance",
          Index: "Colorless transparent liquid without mechanical impurity",
        },
        { Item: "Purity", Index: "99.90 Min" },
        { Item: "Chroma", Index: "5Max" },
        { Item: "Water", Index: "0.04 Max" },
        { Item: "Acidity (Acetic acid)", Index: "0.005 Max" },
        { Item: "Total Aldehyde content", Index: "0.03 Max" },
        { Item: "Density", Index: "0.930~0.934" },
        { Item: "Activity degree", Index: "660 Max" },
        { Item: "Benzene", Index: "0.001Max" },
        { Item: "Distillation range", Index: "1.5Max" },
        { Item: "MTAC", Index: "" },
        { Item: "Inhibitor (Hydroquinone)", Index: "As customer's request." },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
